import { Box, Grid, ResponsiveContext, Text } from 'grommet';
import React, { useContext } from 'react';
import { titlecase, unsnakecase } from '../../../utils/string';
import AddressBlock from '../../AddressBlock';
import Icon from '../../Icon';
import Label from '../../Label';
import NextAnchor from '../../NextAnchor';
import Section from '../../Section';
import {
    IconPencil as IconEdit,
    IconBuilding as IconShop
} from '@tabler/icons-react';

const BusinessDetailsSection = ({ data, isLoading, user }) => {
    const {
        legal_name: legalName,
        business_name: businessName,
        business_type: businessType,
        tax_id: taxId,
        phone_number: phoneNumber,
        address: address,
        website: website,
        primary_contact: {
            first_name: contact_first_name,
            last_name: contact_last_name,
            email: contact_email,
        } = {},
    } = data || {};

    const isOwner = user && user.owner;
    const size = useContext(ResponsiveContext);

    const DataField = ({
        label,
        labelComponent,
        value,
        component
    }) => (
        <Box>
            {label && <Label>{label}</Label>}{labelComponent}
            <Box skeleton={ isLoading ? {animation: 'fadeIn'} : undefined }>
                {<Text margin="none" wordBreak="break-word">{value}</Text>}{component}
            </Box>
        </Box>
    )

    return (
        <Section
            title="Company details"
            icon={IconShop}
            control={
                isOwner && (
                    <NextAnchor
                        href="/settings?action=edit"
                        icon={
                            <Icon
                                SelectedIcon={IconEdit}
                                size="small"
                            />
                        }
                        tip={"Edit details"}
                        button
                    />
                )
            }
        >
            <Grid
                // One column on a phone, where two left each value too narrow
                columns={size === "small" ? ["flex"] : ["1/2", "auto"]}
                gap="medium"
                margin={{ vertical: "small" }}
            >
                <DataField label={"Business legal name"} value={legalName} />
                <DataField label={"Doing business as (DBA)"} value={businessName} />
                <DataField label={"Type of business"} value={titlecase(unsnakecase(businessType))} />
                <DataField label={"Federal ID number"} value={taxId} />
                <DataField label={"Phone number"} value={phoneNumber} />
                <DataField label={"Website"} value={website} />
                <DataField label={"Business address"} component={
                    <AddressBlock
                        onlyAddress
                        address={address}
                        margin="none"
                    />
                }/>
                <DataField label={"Primary contact"} 
                    component={
                        <Box>
                            <Text>{`${contact_first_name} ${contact_last_name}`}</Text>
                            <Text margin="none" wordBreak="break-word">{`${contact_email}`}</Text>
                        </Box>
                    }
                />
            </Grid>
        </Section>
    );
};

export default BusinessDetailsSection;